import { render, staticRenderFns } from "./TextI18nField.vue?vue&type=template&id=5d51e334&scoped=true"
import script from "./TextI18nField.vue?vue&type=script&lang=js"
export * from "./TextI18nField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51e334",
  null
  
)

export default component.exports